import React from 'react';
import classNames from 'classnames';

import { applyOpacityToHex } from '../../../helpers/applyOpacityToHex';

import { TAB_TYPE } from '../../../constants/playbooks';
import { containerClassName, pageHorizontalPaddings } from '../PlaybookTabsView/PlaybookTabsView';

import Loading from '../../../components/Loading';

const TabsViewHeader = ({ type, icon_color, scenario, playbook, prompt }) => {
    if (type === TAB_TYPE.overview) {
        const { name, description } = playbook;

        return (
            <TabViewHeaderContent
                tag="Overview"
                name={name}
                description={description}
                icon_color={icon_color}
            />
        );
    }

    const isLoading =
        (type === TAB_TYPE.form && !scenario) || (type === TAB_TYPE.prompt && !prompt);
    if (isLoading)
        return (
            <div className="flex items-center justify-center pt-8">
                <Loading />
            </div>
        );

    if (type === TAB_TYPE.form) {
        const { name, description } = scenario?.data || {};

        return (
            <TabViewHeaderContent
                tag="Form"
                name={name}
                description={description}
                icon_color={icon_color}
            />
        );
    }

    if (type === TAB_TYPE.prompt) {
        const { name, description } = prompt?.data || {};

        return (
            <TabViewHeaderContent
                tag="Prompt"
                name={name}
                description={description}
                icon_color={icon_color}
            />
        );
    }

    return <></>;
};

function TabViewHeaderContent({ tag, name, description, icon_color }) {
    const tagClassNames = classNames(
        'font-body text-body-regular-m text-neutral-300 uppercase',
        (name || description) && 'mb-2.5'
    );

    return (
        <div
            className={classNames(pageHorizontalPaddings, 'py-[40px]')}
            style={{ backgroundColor: applyOpacityToHex(icon_color, 20) }}
        >
            <div className={containerClassName}>
                <p className={tagClassNames}>{tag}</p>
                {name && (
                    <h1 className="font-body-medium text-[32px] leading-1 text-neutral-500 mb-8">
                        {name}
                    </h1>
                )}
                {description && (
                    <p className="font-body text-body-regular-m text-neutral-300 whitespace-pre-wrap">
                        {description}
                    </p>
                )}
            </div>
        </div>
    );
}

export default TabsViewHeader;
